import React from "react";
import { ArrowDown, FileText, Github, MapPin, Sparkles, Database, Layers } from "lucide-react";
import "./Hero.css";

const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const yOffset = -80;
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="container">
        
        {/* TOP METADATA BAR */}
        <div className="hero-meta-bar">
          <div className="meta-tag">
            <MapPin size={14} className="meta-icon" />
            <span>Shirdi, Maharashtra, India</span>
          </div>
          <div className="meta-divider">•</div>
          <div className="meta-tag">
            <Layers size={14} className="meta-icon" />
            <span>Full Stack &amp; Backend Developer</span>
          </div>
          <div className="meta-divider">•</div>
          <div className="meta-tag">
            <Database size={14} className="meta-icon" />
            <span>Node.js, TypeScript, Python, PostgreSQL</span>
          </div>
        </div>

        {/* HERO EDITORIAL GRID */}
        <div className="hero-grid">
          
          {/* LEFT: EDITORIAL COPY */}
          <div className="hero-content">
            <div className="hero-eyebrow">
              <Sparkles size={14} />
              <span>Prem Bhausaheb Gore — Software Developer</span>
            </div>

            <h1 className="hero-heading">
              Architecting resilient <em>backend systems</em>, operational business software &amp; AI products.
            </h1>

            <p className="hero-description">
              Hands-on software developer experienced in full-stack and backend software development using <strong>JavaScript, TypeScript, Python, and Node.js</strong>. Building production-grade architectures, authentication systems, and realtime workflows across <strong>ERP, CRM, and LMS platforms</strong> with PostgreSQL, Redis, and MongoDB.
            </p>

            {/* ACTION ROW */}
            <div className="hero-actions">
              <button onClick={() => scrollTo("work")} className="btn btn-primary">
                <span>View Selected Work</span>
                <ArrowDown size={16} />
              </button>

              <a
                href="/resume.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline"
                title="View Resume (PDF)"
              >
                <FileText size={16} />
                <span>Resume (PDF)</span>
              </a>

              <a
                href="https://github.com/premgore"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-ghost hero-github-btn"
              >
                <Github size={18} />
                <span>GitHub</span>
              </a>
            </div>

            {/* KEYSTONE PROOF METRICS */}
            <div className="hero-metrics">
              <div className="metric-item">
                <span className="metric-number">3+</span>
                <span className="metric-label">Live Commercial Products</span>
              </div>
              <div className="metric-divider"></div>
              <div className="metric-item">
                <span className="metric-number">100%</span>
                <span className="metric-label">Full Lifecycle Engineering</span>
              </div>
              <div className="metric-divider"></div>
              <div className="metric-item">
                <span className="metric-number">4+</span>
                <span className="metric-label">Production Platforms (ERP/CRM/LMS)</span>
              </div>
            </div>
          </div>

          {/* RIGHT: PROFILE VISUAL & HIGHLIGHT CARD */}
          <div className="hero-visual">
            <div className="profile-frame">
              <div className="profile-image-container">
                <img
                  src="/profile.jpeg"
                  alt="Prem Bhausaheb Gore"
                  className="profile-photo"
                />
                <div className="profile-badge-overlay">
                  <span className="overlay-role">Full Stack &amp; Backend</span>
                  <span className="overlay-sub">JavaScript • Python • TypeScript</span>
                </div>
              </div>
              
              {/* EDITORIAL CAPTION */}
              <div className="profile-caption">
                <div className="caption-dot"></div>
                <div className="caption-text">
                  <strong>Prem Gore</strong> — Focused on scalable architecture, RESTful APIs, and business automation.
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default Hero;